import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//api
import { getClientsApi } from 'api/client';
//component
import AutoCompleteInput from './autoCompleteInput';

const SearchClientInput = ({
  onSelected,
  placeholder = null,
  defaultClient = null
}) => {
  const { t } = useTranslation(['backoffice']);
  const [clientSelected, setClientSelected] = useState(null);

  useEffect(() => {
    if (defaultClient) {
      setClientSelected({
        label: defaultClient.nombre_fiscal || defaultClient.name,
        value: defaultClient.id,
      });
    } else setClientSelected(null)
  }, [defaultClient]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getClientsApi({ search: value, page: 1, page_size: 10 });
      if (status === 200) {
        return data?.results?.map((item) => ({
          ...item,
          label: item.nombre_fiscal,
          value: item.id,
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      defaultOptions={clientSelected ? [clientSelected] : []}
      defaultValue={clientSelected}
      label={t('client')}
      placeholder={placeholder || t('orderTrans.searchByCIFAndName')}
      onSelect={onSelected}
      onSearch={onSearch}
    />
  );
};

SearchClientInput.propTypes = {
  onSelected: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  defaultClient: PropTypes.object,
};

export default SearchClientInput;
